var map = {
	"./carpet.jpg": 2373,
	"./floor.jpg": 9257,
	"./guttering.jpg": 5084,
	"./hoover.jpg": 4534,
	"./roof.jpg": 1984,
	"./rug.jpg": 6609,
	"./sofa.jpg": 8579,
	"./stairs.jpg": 284,
	"./window.jpg": 2502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9795;